require('!!raw-loader!/builds/1002578/v2/src/index.html');